'use strict';

angular.module('ClinicApp').controller('BulkMessagingModalCtrl', function($scope, $modalInstance, clinic, OCModalUtil, requestedAppointments, ClinicService) {
  $scope.clinic = clinic;
  $scope.includeRescheduleLink = true;

  $scope.toggleRescheduleLink = function() {
    $scope.includeRescheduleLink = !$scope.includeRescheduleLink;
  };

  $scope.close = function() {
    $modalInstance.close();
  };

  $scope.sendBulkMessage = function() {
    if (!requestedAppointments) {
      return;
    }

    ClinicService.sendBulkMessage(requestedAppointments, $scope.includeRescheduleLink);

    return ClinicService.updateClinic($scope.clinic, {
      metadata: {
        postCovidBulkMessage: {
          bulkMessageSent: true,
          bulkMessageSkip: false,
          showBulkMessageReminder: false,
          showBulkMessageReminderDate: undefined,
        },
      },
    }).then(function() {
      $modalInstance.close();
      OCModalUtil.showModal(
        'bulkMessagingSuccess',
        {
          status: 'success',
        },
      );
    });
  };

  $scope.setBulkMessageReminder = function() {
    return ClinicService.updateClinic($scope.clinic, {
      metadata: {
        postCovidBulkMessage: {
          bulkMessageSent: false,
          bulkMessageSkip: false,
          showBulkMessageReminder: true,
          showBulkMessageReminderDate: moment().add(1, 'week')
            .format(),
        },
      },
    }).then(function() {
      $modalInstance.close();
      OCModalUtil.showModal('bulkMessagingSuccess', {
        status: 'remind',
      });
    });
  };
});
